import React from 'react';
import AccountCircle from '@mui/icons-material/AccountCircle';
import { IconButton, Popper, Paper, MenuList, Grow, ListItem, ListItemText } from '@mui/material';
import ClickAwayListener from '@mui/material/ClickAwayListener'
import { NavLink, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { ApplicationState } from '../../store';
import { CeclApiState, UserTypes } from '../../store/ceclapi/types';

const UserInfoDropdown = () => {
    const cecl = useSelector<ApplicationState, CeclApiState>((state) => state.cecl);
    const [open, setOpen] = React.useState(false);
    const anchorRef = React.useRef<HTMLButtonElement>(null);
    const location = useLocation();

    const handleToggle = () => {
        setOpen((prevOpen) => !prevOpen);
    };

    const handleClose = () => {
        setOpen(false);
    };

    function handleListKeyDown(event: React.KeyboardEvent) {
        if (event.key === 'Tab') {
            event.preventDefault();
            setOpen(false);
        }
    }

    // return focus to the button when we transitioned from !open -> open
    const prevOpen = React.useRef(open);
    React.useEffect(() => {
        if (prevOpen.current === true && open === false) {
            anchorRef.current!.focus();
        }

        prevOpen.current = open;
    }, [open]);

    return (
        <>
            <IconButton
                ref={anchorRef}
                onClick={handleToggle}
                aria-controls={open ? 'menu-list-grow' : undefined}
                aria-haspopup="true"
                style={{ zIndex: 1000 }}
            >
                <AccountCircle/>
            </IconButton>

            <Popper
                open={open}
                anchorEl={anchorRef.current}
                role={undefined}
                transition
                disablePortal
                placement="bottom-end"
            >
                {({ TransitionProps }) => (
                    <Grow {...TransitionProps} style={{ transformOrigin: 'left' }}>
                        <Paper className="menu">
                            <ClickAwayListener onClickAway={handleClose}>
                                <MenuList autoFocusItem={open} id="menu-list-grow" onKeyDown={handleListKeyDown}>
                                    <ListItem disabled={true}>
                                        <ListItemText id={`list-label-username`} primary={cecl.user?.name} />
                                    </ListItem>
                                    {(location.pathname === '/' || location.pathname.startsWith('/home')) && (
                                        <ListItem button component={NavLink} to={cecl.user?.userType === UserTypes.Admin ? '/usermanagement' : '/dashboard'}>
                                            <ListItemText id={`list-label-dashboard`} primary="Dashboard" />
                                        </ListItem>
                                    )}
                                    <ListItem button component={NavLink} to="/profile">
                                        <ListItemText id={`list-label-profile`} primary="Profile" />
                                    </ListItem>
                                    <ListItem button component={NavLink} to="/logout">
                                        <ListItemText id={`list-label-logout`} primary="Logout" />
                                    </ListItem>
                                </MenuList>
                            </ClickAwayListener>
                        </Paper>
                    </Grow>
                )}
            </Popper>
        </>
    );
};

export default UserInfoDropdown;
